import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Cell,
} from "recharts";
import "../../../../../styles/Pages/Financial/Accountant/Dashboard/HorizontalBarGraph.style.css";

// Custom colors for each bar
const barColors = {
  revenue: "#93B7FF",
  expenses: "#FFC567",
  liabilities: "#82D9D0",
};

// Custom legend component
function CustomLegend({ data }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        gap: "1.5rem",
        marginTop: "1rem",
      }}
    >
      {data.map((item) => (
        <div
          key={item.name}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
            color: "#949596",
          }}
        >
          <div
            style={{
              width: 16,
              height: 16,
              backgroundColor: barColors[item.name],
              borderRadius: 2,
            }}
          />
          <span style={{ textTransform: "capitalize" }}>{item.name}</span>
        </div>
      ))}
    </div>
  );
}

const HorizontalBarGraph = ({ graphData }) => {
  //   console.log(graphData);

  return (
    <div className="horizontalBarGraphComponent">
      <div className="graphHeader">
        <h3>For This Month</h3>
      </div>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          layout="vertical"
          data={graphData.horizontalBarChartData}
          margin={{ top: 20, right: 30, left: 100, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis type="category" dataKey="name" hide />
          <Tooltip
            formatter={(value) => new Intl.NumberFormat().format(value)}
          />
          <Bar dataKey="value" barSize={25}>
            {graphData.horizontalBarChartData.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={barColors[entry.name] || "#8884d8"}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <CustomLegend data={graphData.horizontalBarChartData} />
    </div>
  );
};

export default HorizontalBarGraph;
